// Static JSON data for Abidjan communes and quartiers
export const ABIDJAN_COMMUNES = [
  'Abobo',
  'Adjamé',
  'Attécoubé',
  'Cocody',
  'Koumassi',
  'Marcory',
  'Plateau',
  'Port-Bouët',
  'Treichville',
  'Yopougon',
  'Grand Abidjan (Bingerville, Anyama, Songon)',
  'Bassam',
  'Autre / localité non répertoriée'
];

export const ABIDJAN_QUARTIERS = {
  'Abobo': [
    'Abobo Doumé',
    'Abobo Baoulé',
    'Abobo N\'Dotré',
    'Abobo Gare',
    'Abobo PK 18',
    'Abobo Avocatier',
    'Abobo TE',
    'Abobo Sagbé'
  ],
  'Adjamé': [
    'Adjamé Williamsville',
    'Adjamé Liberté',
    'Adjamé 220 Logements',
    'Adjamé Bracodi',
    'Adjamé Paillet',
    'Adjamé Résidentiel'
  ],
  'Attécoubé': [
    'Attécoubé Santé',
    'Attécoubé Locodjoro',
    'Attécoubé Sagbé',
    'Attécoubé Village',
    'Attécoubé Mairie'
  ],
  'Cocody': [
    'Cocody Riviera Palmeraie',
    'Cocody Riviera 2',
    'Cocody Riviera 3',
    'Cocody Angré',
    'Cocody 2 Plateaux',
    'Cocody Les Valons',
    'Cocody Blockhaus',
    'Cocody Saint Jean',
    'Cocody Ambassades'
  ],
  'Koumassi': [
    'Koumassi Remblais',
    'Koumassi Grand Marché',
    'Koumassi Sicogi',
    'Koumassi Zone Industrielle',
    'Koumassi Nouveau Quartier'
  ],
  'Marcory': [
    'Marcory Zone 4',
    'Marcory Anoumabo',
    'Marcory Remblais',
    'Marcory Biafra',
    'Marcory Résidentiel'
  ],
  'Plateau': [
    'Plateau Centre',
    'Plateau Docki',
    'Plateau Administratif',
    'Plateau Commercial'
  ],
  'Port-Bouët': [
    'Port-Bouët Zone 4',
    'Port-Bouët Zone Industrielle',
    'Port-Bouët Vridi',
    'Port-Bouët Aéroport',
    'Port-Bouët Grand Bassam'
  ],
  'Treichville': [
    'Treichville Centre',
    'Treichville Zone 1',
    'Treichville Zone 2',
    'Treichville Zone 3',
    'Treichville Zone 4',
    'Treichville Abattoir'
  ],
  'Yopougon': [
    'Yopougon Zone 4',
    'Yopougon Niangon',
    'Yopougon Sicogi',
    'Yopougon Andokoi',
    'Yopougon Mamie Adjoua',
    'Yopougon Maroc',
    'Yopougon Banco',
    'Yopougon Wassakara'
  ],
  'Grand Abidjan (Bingerville, Anyama, Songon)': [
    'Bingerville Centre',
    'Bingerville Palmeraie',
    'Anyama Centre',
    'Anyama SIPOREX',
    'Songon Centre',
    'Songon Village'
  ],
  'Bassam': [
    'Bassam Centre',
    'Bassam Cité',
    'Bassam Quartier France',
    'Bassam Moossou',
    'Bassam Impérial',
    'Bassam Nouveau Quartier'
  ],
  'Autre / localité non répertoriée': []
};